import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import { PropTypes, describe } from 'react-desc';
import ReactModal from 'react-modal';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import { MODAL_TYPE_V2 } from '../constants.js';
import { DSModalContent } from './components/ModalContent.js';
export { DSModalContent } from './components/ModalContent.js';
import './components/SelectionHeader.js';
import '@elliemae/ds-basic/form/SearchBox';
import './blocks.js';
import './components/Title.js';
import './components/DecisionHeader.js';
import '@elliemae/ds-icons/Close';
import '@elliemae/ds-basic/Button';
import './components/FormHeader.js';
import './components/FeedbackIcon.js';
import '@elliemae/ds-icons/ErrorHexegon';
import '@elliemae/ds-icons/WarningTriangle';
import '@elliemae/ds-icons/CheckmarkCircle';
import '@elliemae/ds-icons/HelpCircle';
import '@elliemae/ds-icons/InfoCircle';
import './components/Footer.js';
import '@babel/runtime/helpers/esm/extends';
import './helpers.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DSModal = function DSModal(_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size,
      _ref$modalType = _ref.modalType,
      modalType = _ref$modalType === void 0 ? MODAL_TYPE_V2.INFORMATION : _ref$modalType,
      _ref$modalSubType = _ref.modalSubType,
      modalSubType = _ref$modalSubType === void 0 ? null : _ref$modalSubType,
      _ref$modalTitle = _ref.modalTitle,
      modalTitle = _ref$modalTitle === void 0 ? '' : _ref$modalTitle,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'ds-modal' : _ref$dataTestId,
      _ref$centered = _ref.centered,
      centered = _ref$centered === void 0 ? false : _ref$centered,
      _ref$showRejectButton = _ref.showRejectButton,
      showRejectButton = _ref$showRejectButton === void 0 ? false : _ref$showRejectButton,
      _ref$showClose = _ref.showClose,
      showClose = _ref$showClose === void 0 ? true : _ref$showClose,
      _ref$searchProps = _ref.searchProps,
      searchProps = _ref$searchProps === void 0 ? {} : _ref$searchProps,
      _ref$actionsRef = _ref.actionsRef,
      actionsRef = _ref$actionsRef === void 0 ? function () {
    return null;
  } : _ref$actionsRef,
      additionalFooterCssClass = _ref.additionalFooterCssClass,
      _ref$overridePropsCon = _ref.overridePropsConfirmButton,
      overridePropsConfirmButton = _ref$overridePropsCon === void 0 ? {} : _ref$overridePropsCon,
      _ref$overridePropsRej = _ref.overridePropsRejectButton,
      overridePropsRejectButton = _ref$overridePropsRej === void 0 ? {} : _ref$overridePropsRej,
      children = _ref.children,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {
    return null;
  } : _ref$onClose,
      _ref$onAfterOpen = _ref.onAfterOpen,
      onAfterOpen = _ref$onAfterOpen === void 0 ? function () {
    return null;
  } : _ref$onAfterOpen,
      _ref$onConfirm = _ref.onConfirm,
      onConfirm = _ref$onConfirm === void 0 ? function () {
    return null;
  } : _ref$onConfirm,
      _ref$onReject = _ref.onReject,
      onReject = _ref$onReject === void 0 ? function () {
    return null;
  } : _ref$onReject,
      _ref$rejectLabel = _ref.rejectLabel,
      rejectLabel = _ref$rejectLabel === void 0 ? 'Discard' : _ref$rejectLabel,
      _ref$confirmLabel = _ref.confirmLabel,
      confirmLabel = _ref$confirmLabel === void 0 ? 'Save' : _ref$confirmLabel,
      _ref$shouldCloseOnOve = _ref.shouldCloseOnOverlayClick,
      shouldCloseOnOverlayClick = _ref$shouldCloseOnOve === void 0 ? false : _ref$shouldCloseOnOve,
      _ref$appElement = _ref.appElement,
      appElement = _ref$appElement === void 0 ? '#root' : _ref$appElement,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? 10 : _ref$zIndex,
      _ref$removePadding = _ref.removePadding,
      removePadding = _ref$removePadding === void 0 ? false : _ref$removePadding;

  if (typeof document !== 'undefined' && process.env.NODE_ENV !== 'test' && document && ReactModal.setAppElement) {
    ReactModal.setAppElement(appElement);
  }

  var _convertPropToCssClas = convertPropToCssClassName('modal-v2', className, {
    size: size
  }),
      cssClassName = _convertPropToCssClas.cssClassName,
      classNameBlock = _convertPropToCssClas.classNameBlock,
      classNameModifier = _convertPropToCssClas.classNameModifier;

  return /*#__PURE__*/React.createElement(ReactModal, {
    testId: dataTestId,
    className: "".concat(cssClassName, " ").concat(classNameBlock("type-".concat(modalType))),
    contentLabel: modalTitle,
    isOpen: isOpen,
    onAfterOpen: onAfterOpen,
    onRequestClose: onClose,
    overlayClassName: "".concat(classNameBlock('overlay'), " ").concat(classNameModifier(centered ? 'center' : 'top')),
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
    style: {
      content: _objectSpread({}, style),
      overlay: {
        // position: 'absolute', https://jira.elliemae.io/browse/PUI-1471, the overlay should be positioned based on the browser window rather positioned absolute to its parent
        zIndex: zIndex
      }
    }
  }, /*#__PURE__*/React.createElement(DSModalContent, {
    actionsRef: actionsRef,
    additionalFooterCssClass: additionalFooterCssClass,
    confirmLabel: confirmLabel,
    containerProps: containerProps,
    modalSubType: modalSubType,
    modalTitle: modalTitle,
    modalType: modalType,
    onClose: onClose,
    onConfirm: onConfirm,
    onReject: onReject,
    overridePropsConfirmButton: overridePropsConfirmButton,
    overridePropsRejectButton: overridePropsRejectButton,
    rejectLabel: rejectLabel,
    searchProps: searchProps,
    showClose: showClose,
    showRejectButton: showRejectButton,
    removePadding: removePadding
  }, children));
};

var props = {
  /** inject props to container wrapper */
  containerProps: PropTypes.object.description('inject props to container wrapper'),

  /** css class */
  className: PropTypes.string.description('css class'),

  /** style object for container wrapper */
  style: PropTypes.object.description('style object for container wrapper'),

  /** modal container title */
  modalTitle: PropTypes.string.description('modal container title'),

  /** center container */
  centered: PropTypes.bool.description('center container'),

  /** show reject button */
  showRejectButton: PropTypes.bool.description('show reject button'),

  /** show close button */
  showClose: PropTypes.bool.description('show close button'),

  /*
    Props for search component
  */
  searchProps: PropTypes.object.description('Props for search component'),

  /** css class for footer */
  additionalFooterCssClass: PropTypes.string.description('css class for footer'),

  /**  override props confirm button */
  overridePropsConfirmButton: PropTypes.object.description('override props confirm button'),

  /** override props reject button */
  overridePropsRejectButton: PropTypes.object.description('override props reject button'),

  /** controlled isOpen flag */
  isOpen: PropTypes.bool.description('controlled isOpen flag'),

  /** close callback */
  onClose: PropTypes.func.description('close callback'),

  /** after open callback */
  onAfterOpen: PropTypes.func.description('after open callback'),

  /** confirm callback */
  onConfirm: PropTypes.func.description('confirm callback'),

  /** reject callback */
  onReject: PropTypes.func.description('reject callback'),

  /** reject label */
  rejectLabel: PropTypes.string.description('reject label'),

  /** confirm text string */
  confirmLabel: PropTypes.string.description('confirm text string'),

  /** modal container size */
  size: PropTypes.oneOf(['default', 'xx-large', 'x-large', 'large', 'medium', 'small']).description('modal container size'),

  /** modal sub type */
  modalSubType: PropTypes.any.description('modal sub type'),

  /** modal type */
  modalType: PropTypes.any.description('modal type'),

  /** ref for modal footer actions */
  actionsRef: PropTypes.any.description('ref for modal footer actions'),

  /** modal container children */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf([PropTypes.element])]).description('modal container children'),

  /** close on click outside container */
  shouldCloseOnOverlayClick: PropTypes.bool.description('close on click outside container'),

  /*
    App element ID to inject the modal
  */
  appElement: PropTypes.string.description('App element ID to inject the modal'),

  /** zindex for modal container */
  zIndex: PropTypes.number.description('zindex for modal container'),

  /** remove modal builtin padding */
  removePadding: PropTypes.bool.description('remove modal builtin padding')
};
DSModal.propTypes = props;
var DSModalWithSchema = describe(DSModal);
DSModalWithSchema.propTypes = props;

export default DSModal;
export { DSModalWithSchema };
//# sourceMappingURL=DSModal.js.map
